<!-- Filtros -->
<div class="vivo-barra">
  <div class="barra-agrupacion">
    <irx-segmentado
      [(ngModel)]="modoAgrupacion"
      (change)="cambioModoAgrupacion($event)"
    >
      <irx-segmento value="1">Sin agrupar</irx-segmento>
      <irx-segmento value="2">Agrupar por categoría</irx-segmento>
      <irx-segmento value="3">Agrupar por dispositivo</irx-segmento>
      <irx-segmento value="4">Agrupar por módulo</irx-segmento>
      <irx-segmento value="5">Agrupar por cliente</irx-segmento>
      <irx-segmento value="6">Agrupamiento personalizado</irx-segmento>
    </irx-segmentado>

    <!-- Controles del agrupamiento personalizado -->
    @if (modoAgrupacion === '6') {
      <div class="controles-personalizado">
        <button
          irxBoton="secundario"
          class="control-barra"
          [activo]="!filtroPersonalizadoVacio"
          (click)="editarFiltroPersonalizado()"
        >
          <mat-icon class="material-symbols-outlined">filter_alt</mat-icon>
          {{ filtroPersonalizadoVacio ? 'Definir filtro' : 'Editar filtro' }}
        </button>

        <button
          irxBoton="secundario"
          class="control-barra"
          [matMenuTriggerFor]="menuCriterio"
        >
          <mat-icon class="material-symbols-outlined">layers</mat-icon>
          Agrupar por: {{ labelCriterio }}
          <mat-icon class="material-symbols-outlined">expand_more</mat-icon>
        </button>
        <mat-menu #menuCriterio="matMenu">
          @for (c of criterios; track c.valor) {
            <button
              mat-menu-item
              [class.criterio-activo]="c.valor === criterio"
              (click)="cambiarCriterio(c.valor)"
            >
              {{ c.label }}
            </button>
          }
        </mat-menu>
      </div>
    }

    <!-- Buscador expandible -->
    <div
      class="search-container"
      [class.expanded]="searchExpanded || searchTerm"
    >
      <button
        irxBotonIcono
        tooltip="Buscar"
        tono="primario"
        class="search-icon-button"
        (click)="
          searchExpanded = !searchExpanded;
          searchExpanded && searchInput.focus()
        "
      >
        <mat-icon>search</mat-icon>
      </button>
      <input
        #searchInput
        class="search-input"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange()"
        (blur)="onSearchBlur()"
        placeholder="Buscar eventos…"
      />
      @if (searchTerm) {
        <button
          irxBotonIcono
          tooltip="Cerrar"
          class="clear-button"
          (click)="searchTerm = ''; aplicarFiltro(); searchExpanded = false"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  </div>

  <!-- <app-button
    matType="mat-fab extended"
    color="primary"
    icon="filter_alt"
    text="Filtro"
    [matMenuTriggerFor]="filterMenu"
  ></app-button> -->
  <mat-menu #filterMenu="matMenu">
    <div (click)="$event.stopPropagation()" style="padding: 1em">
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 16px;
          justify-content: end;
        "
      >
        <div class="hijos">
          <mat-checkbox
            color="primary"
            [(ngModel)]="query.includeChildren"
            [ngModelOptions]="{ standalone: true }"
            (change)="cambioFiltro()"
          >
            Datos de mis clientes
          </mat-checkbox>
          <input
            class="input-number"
            type="number"
            min="0"
            [(ngModel)]="query.childrenLevel"
            [disabled]="
              query.includeChildren === false || !query.includeChildren
            "
            placeholder="Niveles"
            (change)="cambioFiltro()"
          />
        </div>
      </div>
    </div>
  </mat-menu>
</div>

<!-- Tabla Sin agrupar -->
@if (modoAgrupacion === '1') {
  @if (eventosFiltrados?.length) {
    <mat-table
      [appFilasProgresivas]="eventosFiltrados"
      [trackBy]="trackPorId"
      class="mat-elevation-z8"
    >
      <!-- Categoría -->
      <ng-container matColumnDef="categoria">
        <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <!-- Badge del color de la categoría con el nombre adentro -->
          <span
            class="irx-estado"
            [class.irx-estado--color]="!!colorCategoria(element)"
            [class.irx-estado--neutro]="!colorCategoria(element)"
            [style.--estado-color]="colorCategoria(element)" [style.--estado-texto-sobre]="textoCategoria(element)"
          >
            {{ this.eventosHelper.obtenerCategoria(element) }}
          </span>
        </mat-cell>
      </ng-container>

      <!-- Nombre Evento -->
      <ng-container matColumnDef="evento">
        <mat-header-cell *matHeaderCellDef>Evento</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.valores?.titulo) {
            {{ element.valores.titulo }}
          } @else {
            <span class="no-info">Sin título</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Detalles Evento -->
      <ng-container matColumnDef="detallesEvento">
        <mat-header-cell *matHeaderCellDef>Detalles</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.valores?.detalles || element.valores?.mensaje) {
            {{ element.valores?.detalles || element.valores?.mensaje }}
          } @else {
            <span class="no-info">Sin detalles</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Entidad -->
      <ng-container matColumnDef="entidad">
        <mat-header-cell *matHeaderCellDef>Entidad</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (obtenerEntidadInfo(element); as entidadInfo) {
            <span class="vivo-linea">
              <mat-icon>{{ entidadInfo.icono }}</mat-icon>
              <span>{{ entidadInfo.texto }}</span>
            </span>
          } @else {
            <span class="no-info">Sin asignar</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Estado -->
      <ng-container matColumnDef="estado">
        <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="vivo-estado-celda">
            @if (estadoEvento(element.estado); as estado) {
              <span class="irx-estado irx-estado--{{ estado.tono }}">
                @if (estado.icono) {
                  <mat-icon>{{ estado.icono }}</mat-icon>
                }
                {{ estado.texto }}
              </span>
            } @else {
              <span class="no-info">Sin estado</span>
            }
            @if (element.usuariosAtendiendo?.length) {
              <span
                class="chip-atendiendo"
                [matTooltip]="'Atendiendo: ' + nombresAtendiendo(element)"
              >
                <mat-icon>person</mat-icon>
                {{ element.usuariosAtendiendo.length | number }}
              </span>
            }
          </span>
        </mat-cell>
      </ng-container>

      <!-- Cliente -->
      <ng-container matColumnDef="cliente">
        <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.cliente?.nombre) {
            {{ element.cliente.nombre }}
          } @else {
            <span class="no-info">Sin cliente</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Fecha -->
      <ng-container matColumnDef="fecha">
        <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>

        <mat-cell *matCellDef="let element">
          @if (element.fechaCreacion) {
            <span class="vivo-fecha" [matTooltip]="tooltipFecha(element)">
              <span>{{ fechaCelda(element.fechaCreacion) }}</span>
              <span class="vivo-secundario">
                {{ haceCelda(element.fechaCreacion) }}
              </span>
              @if (
                !sonFechasIguales(
                  element.fechaCreacion,
                  element.fechaUltimoRepetido
                )
              ) {
                <span class="vivo-secundario">
                  Última repetición:
                  {{ fechaCelda(element.fechaUltimoRepetido) }} ·
                  {{ haceCelda(element.fechaUltimoRepetido) }}
                </span>
              }
            </span>
          } @else {
            <span class="no-info">Sin fecha</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Repetidos -->
      <ng-container matColumnDef="repetido">
        <mat-header-cell *matHeaderCellDef>Repetidos</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.repetido != null) {
            {{ element.repetido | number }}
          } @else {
            <span class="no-info">Sin repeticiones</span>
          }
        </mat-cell>
      </ng-container>

      <!-- Columna Acciones -->
      <ng-container matColumnDef="acciones">
        <mat-header-cell *matHeaderCellDef>Acción</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <button
            irxBotonIcono
            tono="primario"
            tooltip="Atender"
            (click)="$event.stopPropagation(); tratar(row)"
          >
            <mat-icon>troubleshoot</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="columnas"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: columnas"
        [style.border-left]="
          '5px solid ' + (row.valores?.color || 'transparent')
        "
      ></mat-row>
    </mat-table>
  }
}

<!-- Agrupado por categoria -->
@if (modoAgrupacion === '2') {
  <mat-accordion displayMode="flat">
    @for (categoria of categorias; track categoria.nombre) {
      <mat-expansion-panel
        [expanded]="categoria.nombre === panelExpanded"
        (afterExpand)="panelExpanded = categoria.nombre"
      >
        <mat-expansion-panel-header
          class="irx-sobre-color vivo-panel-header"
          [style.background-color]="categoria.color"
        >
          <mat-panel-title
            [ngStyle]="{
              color: categoria.colorTexto,
            }"
          >
            {{ categoria.nombre }}
          </mat-panel-title>
          <div class="vivo-acciones-grupo">
            <!-- Boton finalizar todos -->
            @if (puedeFinalizar) {
              <button
                irxBoton="peligro-borde"
                tamano="compacto"
                (click)="
                  $event.stopPropagation();
                  finalizarTodosPorCategoria(categoria.nombre)
                "
              >
                <mat-icon>task_alt</mat-icon>
                Finalizar todos:
                {{ eventosPorCategoria?.[categoria.nombre].length }}
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <!-- Contenido de administracion -->
        <!-- ng-template => el contenido se renderiza recién al expandir -->
        <ng-template matExpansionPanelContent>
          <div class="expansion-content">
            <mat-table
              [appFilasProgresivas]="
                eventosPorCategoria?.[categoria.nombre] || []
              "
              [trackBy]="trackPorId"
              class="mat-elevation-z8"
            >
              <!-- Nombre Evento -->
              <ng-container matColumnDef="evento">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Evento
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.titulo) {
                    {{ element.valores.titulo }}
                  } @else {
                    <span class="no-info">Sin título</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Repetidos -->
              <ng-container matColumnDef="repetido">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Repetidos
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.repetido != null) {
                    {{ element.repetido | number }}
                  } @else {
                    <span class="no-info">Sin repeticiones</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Entidad-->
              <ng-container matColumnDef="entidad">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Entidad
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (obtenerEntidadInfo(element); as entidadInfo) {
                    <span class="vivo-linea">
                      <mat-icon>{{ entidadInfo.icono }}</mat-icon>
                      <span>{{ entidadInfo.texto }}</span>
                    </span>
                  } @else {
                    <span class="no-info">Sin asignar</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Detalles Evento -->
              <ng-container matColumnDef="detallesEvento">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Detalles
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.detalles || element.valores?.mensaje) {
                    {{ element.valores?.detalles || element.valores?.mensaje }}
                  } @else {
                    <span class="no-info">Sin detalles</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="estado">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Estado
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="vivo-estado-celda">
                    @if (estadoEvento(element.estado); as estado) {
                      <span class="irx-estado irx-estado--{{ estado.tono }}">
                        @if (estado.icono) {
                          <mat-icon>{{ estado.icono }}</mat-icon>
                        }
                        {{ estado.texto }}
                      </span>
                    } @else {
                      <span class="no-info">Sin estado</span>
                    }
                    @if (element.usuariosAtendiendo?.length) {
                      <span
                        class="chip-atendiendo"
                        [matTooltip]="
                          'Atendiendo: ' + nombresAtendiendo(element)
                        "
                      >
                        <mat-icon>person</mat-icon>
                        {{ element.usuariosAtendiendo.length | number }}
                      </span>
                    }
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Cliente -->
              <ng-container matColumnDef="cliente">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Cliente
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.cliente?.nombre) {
                    {{ element.cliente.nombre }}
                  } @else {
                    <span class="no-info">Sin cliente</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Fecha -->
              <ng-container matColumnDef="fecha">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Fecha
                </mat-header-cell>

                <mat-cell *matCellDef="let element">
                  @if (element.fechaCreacion) {
                    <span
                      class="vivo-fecha"
                      [matTooltip]="tooltipFecha(element)"
                    >
                      <span>{{ fechaCelda(element.fechaCreacion) }}</span>
                      <span class="vivo-secundario">
                        {{ haceCelda(element.fechaCreacion) }}
                      </span>
                      @if (
                        !sonFechasIguales(
                          element.fechaCreacion,
                          element.fechaUltimoRepetido
                        )
                      ) {
                        <span class="vivo-secundario">
                          Última repetición:
                          {{ fechaCelda(element.fechaUltimoRepetido) }} ·
                          {{ haceCelda(element.fechaUltimoRepetido) }}
                        </span>
                      }
                    </span>
                  } @else {
                    <span class="no-info">Sin fecha</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Columna Acciones -->
              <ng-container matColumnDef="acciones">
                <mat-header-cell
                  *matHeaderCellDef
                  [ngStyle]="{
                    color: categoria.colorTexto,
                  }"
                >
                  Acción
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button
                    irxBotonIcono
                    tono="primario"
                    tooltip="Atender"
                    (click)="$event.stopPropagation(); tratar(row)"
                  >
                    <mat-icon>troubleshoot</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row
                [style.background-color]="categoria.color"
                *matHeaderRowDef="columnasAgrupadoCategoria"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: columnasAgrupadoCategoria"
                [style.border-left]="
                  '5px solid ' + (row.valores?.color || 'transparent')
                "
              ></mat-row>
            </mat-table>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

<!-- Agrupado por dispositivo -->
@if (modoAgrupacion === '3') {
  <mat-accordion displayMode="flat">
    @for (entidad of entidades; track entidad.nombre) {
      <mat-expansion-panel
        [expanded]="entidad.nombre === panelExpanded"
        (afterExpand)="panelExpanded = entidad.nombre"
      >
        <mat-expansion-panel-header class="vivo-panel-header">
          <mat-panel-title>
            {{ entidad.nombre }}
            <small class="vivo-contador no-info">
              {{
                eventosPorEntidad?.[entidad.nombre]?.length > 0
                  ? '(Eventos: ' +
                    eventosPorEntidad?.[entidad.nombre].length +
                    ')'
                  : ''
              }}
            </small>
          </mat-panel-title>
          <div class="vivo-acciones-grupo">
            <!-- Boton atender -->
            <button
              irxBotonIcono="borde"
              tono="primario"
              tamano="compacto"
              tooltip="Atender"
              (click)="
                $event.stopPropagation();
                tratar(
                  eventosPorEntidad?.[entidad.nombre][
                    eventosPorEntidad?.[entidad.nombre].length - 1
                  ]
                )
              "
            >
              <mat-icon>troubleshoot</mat-icon>
            </button>
            <!-- Boton detalles -->
            <button
              irxBotonIcono="borde"
              tono="primario"
              tamano="compacto"
              [tooltip]="'Ver detalle de ' + entidad.nombre"
              (click)="
                irADetalles(eventosPorEntidad?.[entidad.nombre][0] || null)
              "
            >
              <mat-icon>visibility</mat-icon>
            </button>
            <!-- Boton finalizar todos -->
            @if (puedeFinalizar) {
              <button
                irxBoton="peligro-borde"
                tamano="compacto"
                (click)="
                  $event.stopPropagation();
                  finalizarTodosPorEntidad(entidad.nombre)
                "
              >
                <mat-icon>task_alt</mat-icon>
                Finalizar todos:
                {{ eventosPorEntidad?.[entidad.nombre].length }}
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <!-- Contenido de administracion -->
        <!-- ng-template => el contenido se renderiza recién al expandir -->
        <ng-template matExpansionPanelContent>
          <div class="expansion-content">
            <mat-table
              [appFilasProgresivas]="eventosPorEntidad?.[entidad.nombre] || []"
              [trackBy]="trackPorId"
              class="mat-elevation-z8"
            >
              <!-- Categoria -->
              <ng-container matColumnDef="categoria">
                <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <!-- Badge del color de la categoría con el nombre adentro -->
                  <span
                    class="irx-estado"
                    [class.irx-estado--color]="!!colorCategoria(element)"
                    [class.irx-estado--neutro]="!colorCategoria(element)"
                    [style.--estado-color]="colorCategoria(element)" [style.--estado-texto-sobre]="textoCategoria(element)"
                  >
                    {{ this.eventosHelper.obtenerCategoria(element) }}
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Nombre Evento -->
              <ng-container matColumnDef="evento">
                <mat-header-cell *matHeaderCellDef>Evento</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.titulo) {
                    {{ element.valores.titulo }}
                  } @else {
                    <span class="no-info">Sin título</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Detalles Evento -->
              <ng-container matColumnDef="detallesEvento">
                <mat-header-cell *matHeaderCellDef>Detalles</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.detalles || element.valores?.mensaje) {
                    {{ element.valores?.detalles || element.valores?.mensaje }}
                  } @else {
                    <span class="no-info">Sin detalles</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Repetidos -->
              <ng-container matColumnDef="repetido">
                <mat-header-cell *matHeaderCellDef>Repetidos</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.repetido != null) {
                    {{ element.repetido | number }}
                  } @else {
                    <span class="no-info">Sin repeticiones</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="estado">
                <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="vivo-estado-celda">
                    @if (estadoEvento(element.estado); as estado) {
                      <span class="irx-estado irx-estado--{{ estado.tono }}">
                        @if (estado.icono) {
                          <mat-icon>{{ estado.icono }}</mat-icon>
                        }
                        {{ estado.texto }}
                      </span>
                    } @else {
                      <span class="no-info">Sin estado</span>
                    }
                    @if (element.usuariosAtendiendo?.length) {
                      <span
                        class="chip-atendiendo"
                        [matTooltip]="
                          'Atendiendo: ' + nombresAtendiendo(element)
                        "
                      >
                        <mat-icon>person</mat-icon>
                        {{ element.usuariosAtendiendo.length | number }}
                      </span>
                    }
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Cliente -->
              <ng-container matColumnDef="cliente">
                <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.cliente?.nombre) {
                    {{ element.cliente.nombre }}
                  } @else {
                    <span class="no-info">Sin cliente</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Fecha -->
              <ng-container matColumnDef="fecha">
                <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>

                <mat-cell *matCellDef="let element">
                  @if (element.fechaCreacion) {
                    <span
                      class="vivo-fecha"
                      [matTooltip]="tooltipFecha(element)"
                    >
                      <span>{{ fechaCelda(element.fechaCreacion) }}</span>
                      <span class="vivo-secundario">
                        {{ haceCelda(element.fechaCreacion) }}
                      </span>
                      @if (
                        !sonFechasIguales(
                          element.fechaCreacion,
                          element.fechaUltimoRepetido
                        )
                      ) {
                        <span class="vivo-secundario">
                          Última repetición:
                          {{ fechaCelda(element.fechaUltimoRepetido) }} ·
                          {{ haceCelda(element.fechaUltimoRepetido) }}
                        </span>
                      }
                    </span>
                  } @else {
                    <span class="no-info">Sin fecha</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Columna Acciones -->
              <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef>Acción</mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button
                    irxBotonIcono
                    tono="primario"
                    tooltip="Atender"
                    (click)="$event.stopPropagation(); tratar(row)"
                  >
                    <mat-icon>troubleshoot</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="columnasAgrupadoEntidad"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: columnasAgrupadoEntidad"
                [style.border-left]="
                  '5px solid ' + (row.valores?.color || 'transparent')
                "
              ></mat-row>
            </mat-table>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

<!-- Agrupado por tipo de dispositivo -->
@if (modoAgrupacion === '4') {
  <mat-accordion displayMode="flat">
    @for (tipoEntidad of tiposEntidades; track tipoEntidad.nombre) {
      <mat-expansion-panel
        [expanded]="tipoEntidad.nombre === panelExpanded"
        (afterExpand)="panelExpanded = tipoEntidad.nombre"
      >
        <mat-expansion-panel-header class="vivo-panel-header">
          <mat-panel-title>
            {{ tipoEntidad.nombre }}
            <small class="vivo-contador no-info">
              {{
                eventosPorTipoEntidad?.[tipoEntidad.nombre]?.length > 0
                  ? '(Eventos: ' +
                    eventosPorTipoEntidad?.[tipoEntidad.nombre].length +
                    ')'
                  : ''
              }}
            </small>
          </mat-panel-title>
          <div class="vivo-acciones-grupo">
            <!-- Boton finalizar todos -->
            @if (puedeFinalizar) {
              <button
                irxBoton="peligro-borde"
                tamano="compacto"
                (click)="
                  $event.stopPropagation();
                  finalizarTodosPorTipo(tipoEntidad.nombre)
                "
              >
                <mat-icon>task_alt</mat-icon>
                Finalizar todos:
                {{ eventosPorTipoEntidad?.[tipoEntidad.nombre].length }}
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <!-- Contenido de administracion -->
        <!-- ng-template => el contenido se renderiza recién al expandir -->
        <ng-template matExpansionPanelContent>
          <div class="expansion-content">
            <mat-table
              [appFilasProgresivas]="
                eventosPorTipoEntidad?.[tipoEntidad.nombre] || []
              "
              [trackBy]="trackPorId"
              class="mat-elevation-z8"
            >
              <!-- Categoria -->
              <ng-container matColumnDef="categoria">
                <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <!-- Badge del color de la categoría con el nombre adentro -->
                  <span
                    class="irx-estado"
                    [class.irx-estado--color]="!!colorCategoria(element)"
                    [class.irx-estado--neutro]="!colorCategoria(element)"
                    [style.--estado-color]="colorCategoria(element)" [style.--estado-texto-sobre]="textoCategoria(element)"
                  >
                    {{ this.eventosHelper.obtenerCategoria(element) }}
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Nombre Evento -->
              <ng-container matColumnDef="evento">
                <mat-header-cell *matHeaderCellDef>Evento</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.titulo) {
                    {{ element.valores.titulo }}
                  } @else {
                    <span class="no-info">Sin título</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Detalles Evento -->
              <ng-container matColumnDef="detallesEvento">
                <mat-header-cell *matHeaderCellDef>Detalles</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.valores?.detalles || element.valores?.mensaje) {
                    {{ element.valores?.detalles || element.valores?.mensaje }}
                  } @else {
                    <span class="no-info">Sin detalles</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Entidad -->
              <ng-container matColumnDef="entidad">
                <mat-header-cell *matHeaderCellDef>Entidad</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (obtenerEntidadInfo(element); as entidadInfo) {
                    <span class="vivo-linea">
                      <mat-icon>{{ entidadInfo.icono }}</mat-icon>
                      <span>{{ entidadInfo.texto }}</span>
                    </span>
                  } @else {
                    <span class="no-info">Sin asignar</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Repetidos -->
              <ng-container matColumnDef="repetido">
                <mat-header-cell *matHeaderCellDef>Repetidos</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.repetido != null) {
                    {{ element.repetido | number }}
                  } @else {
                    <span class="no-info">Sin repeticiones</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Estado -->
              <ng-container matColumnDef="estado">
                <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  <span class="vivo-estado-celda">
                    @if (estadoEvento(element.estado); as estado) {
                      <span class="irx-estado irx-estado--{{ estado.tono }}">
                        @if (estado.icono) {
                          <mat-icon>{{ estado.icono }}</mat-icon>
                        }
                        {{ estado.texto }}
                      </span>
                    } @else {
                      <span class="no-info">Sin estado</span>
                    }
                    @if (element.usuariosAtendiendo?.length) {
                      <span
                        class="chip-atendiendo"
                        [matTooltip]="
                          'Atendiendo: ' + nombresAtendiendo(element)
                        "
                      >
                        <mat-icon>person</mat-icon>
                        {{ element.usuariosAtendiendo.length | number }}
                      </span>
                    }
                  </span>
                </mat-cell>
              </ng-container>

              <!-- Cliente -->
              <ng-container matColumnDef="cliente">
                <mat-header-cell *matHeaderCellDef>Cliente</mat-header-cell>
                <mat-cell *matCellDef="let element">
                  @if (element.cliente?.nombre) {
                    {{ element.cliente.nombre }}
                  } @else {
                    <span class="no-info">Sin cliente</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Fecha -->
              <ng-container matColumnDef="fecha">
                <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>

                <mat-cell *matCellDef="let element">
                  @if (element.fechaCreacion) {
                    <span
                      class="vivo-fecha"
                      [matTooltip]="tooltipFecha(element)"
                    >
                      <span>{{ fechaCelda(element.fechaCreacion) }}</span>
                      <span class="vivo-secundario">
                        {{ haceCelda(element.fechaCreacion) }}
                      </span>
                      @if (
                        !sonFechasIguales(
                          element.fechaCreacion,
                          element.fechaUltimoRepetido
                        )
                      ) {
                        <span class="vivo-secundario">
                          Última repetición:
                          {{ fechaCelda(element.fechaUltimoRepetido) }} ·
                          {{ haceCelda(element.fechaUltimoRepetido) }}
                        </span>
                      }
                    </span>
                  } @else {
                    <span class="no-info">Sin fecha</span>
                  }
                </mat-cell>
              </ng-container>

              <!-- Columna Acciones -->
              <ng-container matColumnDef="acciones">
                <mat-header-cell *matHeaderCellDef>Acción</mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <button
                    irxBotonIcono
                    tono="primario"
                    tooltip="Atender"
                    (click)="$event.stopPropagation(); tratar(row)"
                  >
                    <mat-icon>troubleshoot</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>
              <mat-header-row
                *matHeaderRowDef="columnasAgrupadoTipoEntidad"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: columnasAgrupadoTipoEntidad"
                [style.border-left]="
                  '5px solid ' + (row.valores?.color || 'transparent')
                "
              ></mat-row>
            </mat-table>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

<!-- Agrupado por cliente -->
@if (modoAgrupacion === '5') {
  <mat-accordion displayMode="flat">
    @for (cliente of clientes; track cliente.nombre) {
      <mat-expansion-panel
        [expanded]="cliente.nombre === panelExpanded"
        (afterExpand)="panelExpanded = cliente.nombre"
      >
        <mat-expansion-panel-header class="vivo-panel-header">
          <mat-panel-title>
            {{ cliente.nombre }}
            <small class="vivo-contador no-info">
              {{
                eventosPorCliente?.[cliente.nombre]?.length > 0
                  ? '(Eventos: ' +
                    eventosPorCliente?.[cliente.nombre].length +
                    ')'
                  : ''
              }}
            </small>
          </mat-panel-title>
          <div class="vivo-acciones-grupo">
            <!-- Boton finalizar todos -->
            @if (puedeFinalizar) {
              <button
                irxBoton="peligro-borde"
                tamano="compacto"
                (click)="
                  $event.stopPropagation();
                  finalizarTodosPorCliente(cliente.nombre)
                "
              >
                <mat-icon>task_alt</mat-icon>
                Finalizar todos:
                {{ eventosPorCliente?.[cliente.nombre].length }}
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <!-- Contenido de administracion -->
        <!-- ng-template => el contenido se renderiza recién al expandir -->
        <ng-template matExpansionPanelContent>
          <div class="expansion-content">
            <ng-container
              *ngTemplateOutlet="
                tablaGrupo;
                context: {
                  lista: eventosPorCliente?.[cliente.nombre] || [],
                  columnas: columnasAgrupadoCliente,
                }
              "
            ></ng-container>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

<!-- Agrupamiento personalizado -->
@if (modoAgrupacion === '6') {
  @if (truncadoPersonalizado) {
    <!-- El listado vivo esta capado: agrupar sin decirlo seria mentir sobre el
         tamano de cada grupo. -->
    <app-hint
      icon="warning"
      color="orange"
      [message]="
        'Mostrando ' +
        cargadosPersonalizado +
        ' de ' +
        totalCountPersonalizado +
        ' eventos. Afiná el filtro para ver el total; finalizar o tratar un grupo sí alcanza a todos.'
      "
    ></app-hint>
  }

  @if (!gruposPersonalizados.length && !loading) {
    <div class="sin-grupos no-info">No hay eventos que cumplan el filtro.</div>
  }

  <mat-accordion displayMode="flat">
    @for (grupo of gruposPersonalizados; track grupo.clave) {
      <mat-expansion-panel
        [expanded]="grupo.clave === panelExpanded"
        (afterExpand)="panelExpanded = grupo.clave"
      >
        <mat-expansion-panel-header class="vivo-panel-header">
          <mat-panel-title>
            {{ grupo.label }}
            <small class="vivo-contador no-info">
              {{
                eventosPorGrupo?.[grupo.clave]?.length > 0
                  ? '(Eventos: ' + eventosPorGrupo?.[grupo.clave].length + ')'
                  : ''
              }}
            </small>
          </mat-panel-title>
          <div class="vivo-acciones-grupo">
            <button
              irxBoton="principal"
              tamano="compacto"
              (click)="$event.stopPropagation(); tratarGrupo(grupo)"
            >
              <mat-icon>troubleshoot</mat-icon>
              Tratar grupo
            </button>
            @if (puedeFinalizar) {
              <button
                irxBoton="peligro-borde"
                tamano="compacto"
                (click)="$event.stopPropagation(); finalizarGrupo(grupo)"
              >
                <mat-icon>task_alt</mat-icon>
                Finalizar grupo
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <div class="expansion-content">
            <ng-container
              *ngTemplateOutlet="
                tablaGrupo;
                context: {
                  lista: eventosPorGrupo?.[grupo.clave] || [],
                  columnas: columnasAgrupadoCliente,
                }
              "
            ></ng-container>
          </div>
        </ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
}

@if (loading) {
  <div class="vivo-aviso">
    <app-loading text="Cargando eventos"></app-loading>
  </div>
}

@if (!eventosFiltrados.length && !loading) {
  <div class="vivo-aviso">
    @if (searchTerm) {
      <app-empty-state
        title="No se encontraron eventos"
        subtitle="No hay eventos que coincidan con '{{ searchTerm }}'"
      ></app-empty-state>
    } @else {
      <app-empty-state
        title="No hay eventos pendientes"
        subtitle="Los eventos nuevos van a aparecer acá."
      ></app-empty-state>
    }
  </div>
}

<!-- Tabla de un grupo. Una sola definicion parametrizada por la lista y el
     set de columnas: el markup de la tabla estaba repetido en cada modo de
     agrupacion, y el modo personalizado habria sido la quinta copia. -->
<ng-template #tablaGrupo let-lista="lista" let-columnas="columnas">
  <mat-table
    [appFilasProgresivas]="lista"
    [trackBy]="trackPorId"
    class="mat-elevation-z8"
  >
    <!-- Categoria -->
    <ng-container matColumnDef="categoria">
      <mat-header-cell *matHeaderCellDef>Categoría</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <!-- Badge del color de la categoría con el nombre adentro -->
        <span
          class="irx-estado"
          [class.irx-estado--color]="!!colorCategoria(element)"
          [class.irx-estado--neutro]="!colorCategoria(element)"
          [style.--estado-color]="colorCategoria(element)" [style.--estado-texto-sobre]="textoCategoria(element)"
        >
          {{ this.eventosHelper.obtenerCategoria(element) }}
        </span>
      </mat-cell>
    </ng-container>

    <!-- Nombre Evento -->
    <ng-container matColumnDef="evento">
      <mat-header-cell *matHeaderCellDef>Evento</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.valores?.titulo) {
          {{ element.valores.titulo }}
        } @else {
          <span class="no-info">Sin título</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Detalles Evento -->
    <ng-container matColumnDef="detallesEvento">
      <mat-header-cell *matHeaderCellDef>Detalles</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.valores?.detalles || element.valores?.mensaje) {
          {{ element.valores?.detalles || element.valores?.mensaje }}
        } @else {
          <span class="no-info">Sin detalles</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Entidad -->
    <ng-container matColumnDef="entidad">
      <mat-header-cell *matHeaderCellDef>Entidad</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (obtenerEntidadInfo(element); as entidadInfo) {
          <span class="vivo-linea">
            <mat-icon>{{ entidadInfo.icono }}</mat-icon>
            <span>{{ entidadInfo.texto }}</span>
          </span>
        } @else {
          <span class="no-info">Sin asignar</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Repetidos -->
    <ng-container matColumnDef="repetido">
      <mat-header-cell *matHeaderCellDef>Repetidos</mat-header-cell>
      <mat-cell *matCellDef="let element">
        @if (element.repetido != null) {
          {{ element.repetido | number }}
        } @else {
          <span class="no-info">Sin repeticiones</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Estado -->
    <ng-container matColumnDef="estado">
      <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <span class="vivo-estado-celda">
          @if (estadoEvento(element.estado); as estado) {
            <span class="irx-estado irx-estado--{{ estado.tono }}">
              @if (estado.icono) {
                <mat-icon>{{ estado.icono }}</mat-icon>
              }
              {{ estado.texto }}
            </span>
          } @else {
            <span class="no-info">Sin estado</span>
          }
          @if (element.usuariosAtendiendo?.length) {
            <span
              class="chip-atendiendo"
              [matTooltip]="'Atendiendo: ' + nombresAtendiendo(element)"
            >
              <mat-icon>person</mat-icon>
              {{ element.usuariosAtendiendo.length | number }}
            </span>
          }
        </span>
      </mat-cell>
    </ng-container>

    <!-- Fecha -->
    <ng-container matColumnDef="fecha">
      <mat-header-cell *matHeaderCellDef>Fecha</mat-header-cell>

      <mat-cell *matCellDef="let element">
        @if (element.fechaCreacion) {
          <span class="vivo-fecha" [matTooltip]="tooltipFecha(element)">
            <span>{{ fechaCelda(element.fechaCreacion) }}</span>
            <span class="vivo-secundario">
              {{ haceCelda(element.fechaCreacion) }}
            </span>
            @if (
              !sonFechasIguales(
                element.fechaCreacion,
                element.fechaUltimoRepetido
              )
            ) {
              <span class="vivo-secundario">
                Última repetición:
                {{ fechaCelda(element.fechaUltimoRepetido) }} ·
                {{ haceCelda(element.fechaUltimoRepetido) }}
              </span>
            }
          </span>
        } @else {
          <span class="no-info">Sin fecha</span>
        }
      </mat-cell>
    </ng-container>

    <!-- Columna Acciones -->
    <ng-container matColumnDef="acciones">
      <mat-header-cell *matHeaderCellDef>Acción</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <button
          irxBotonIcono
          tono="primario"
          tooltip="Atender"
          (click)="$event.stopPropagation(); tratar(row)"
        >
          <mat-icon>troubleshoot</mat-icon>
        </button>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnas"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: columnas"
      [style.border-left]="'5px solid ' + (row.valores?.color || 'transparent')"
    ></mat-row>
  </mat-table>
</ng-template>
